export default {
  SITE_NAME: 'TargetOptical.com',
  CART_PREVIEW_CONTAINER: 'Your cart preview',
  CART_MISSING_PRESCRIPTION: `We'll ask for your prescription after your order`,
  SUBTOTAL_HEADER: 'Subtotal',
  SUBTOTAL_TEXT: 'Pay over time in interest-free installments with Affirm or Afterpay',
  SUBTOTAL_LINK_TEXT: 'Learn More',
  SUBTOTAL_BTN_TEXT: 'go to cart',
  CART_PREVIEW_EMPTY_TITLE: 'Your cart is empty.',
  CART_PREVIEW_EMPTY_SUBTITLE: 'Start shopping, you’ll love everything in sight!',
  WISHLIST_PREVIEW_EMPTY_TITLE: 'No saved items yet.',
  WISHLIST_PREVIEW_EMPTY_SUBTITLE: 'Tap the heart icon to save your favourite products for later',
  CART_PREVIEW_EYEGLASSES: 'Shop eyeglasses',
  CART_PREVIEW_SUNGLASSES: 'Shop sunglasses',
  CART_PREVIEW_CONTACTS: 'Shop contacts',
  WISHLIST_ITEM_COUNT: 'Saved items',
  WISHLIST_BROWSE_ALL: 'Browse all',
  OFF_LABEL: 'off',
  FRAME_PROMO_LABEL: 'frame',
  LENS_COLOR_PREVIEW_NOT_AVAILABLE: 'Lens preview unavailable',
  LENS_COLOR_PREVIEW_TEXT: 'You will receive the lens color you selected',
  REMOVE_ITEM_LABEL: 'Remove',
  EDIT_ITEM_LABEL: 'Edit',
  CURRENCY_LABEL: '$',
  PERCENTAGE_OFF_LABEL: '{DISCOUNT_PERCENTAGE}% Off',
  YOUR_LENSES_LABEL: 'Your lenses',
  QUANTITY_CONTACT_LABEL: 'quantity',
  EYE_CONTACT_LABEL: 'eye',
  BC_CONTACT_LABEL: 'bc',
  DIA_CONTACT_LABEL: 'dia',
  POWER_CONTACT_LABEL: 'power',
  CYL_CONTACT_LABEL: 'cyl',
  AXIS_CONTACT_LABEL: 'axis',
  DOMINANCE_CONTACT_LABEL: 'dom',
  EDIT_CONTACT_LABEL: 'edit',
  RIGHT_CONTACT_LABEL: 'right',
  LC_RIGHT_CONTACT_LABEL: 'RIGHT EYE (OD)',
  LEFT_CONTACT_LABEL: 'left',
  LC_LEFT_CONTACT_LABEL: 'LEFT EYE (OS)',
  PROMO_APPLIED_LABEL: 'Promo applied',
  PRICES_PER_BOX_LABEL: 'Price per Box',
  LC_PRICES_BOX_SUBTOTAL_LABEL: 'boxes subtotal',
  ANNUAL_SUPPLY_LABEL: 'You are saving ##CURRENCY####VALUE## on your annual supply!',
  LC_ANNUAL_SUPPLY_LABEL: 'Annual supply savings',
  SUBTOTAL_LABEL: 'Subtotal',
  NUM_BOX_LABEL: '(##BOXES## boxes)',
  UNDO_MESSAGE_LABEL: ' was removed from your bag.',
  UNDO_LABEL: 'Undo',
  WISHLIST_FRAME_COLOR: 'Frame color',
  WISHLIST_FRAME_SIZE: 'Size',
  WISHLIST_LENSES_COLOR: 'Lenses',
  LC_WISHLIST_LENSES_COLOR: 'Your lenses',
  WISHLIST_REMOVE_ITEM: 'Remove',
  WISHLIST_SELECT_LENSES: 'select lenses',
  WISHLIST_SELECT_PRESCRIPTION_LENSES: 'select prescription lenses',
  WISHLIST_PROTECTION_PLAN: 'Add ',
  WISHLIST_PROTECTION_PLAN_LINK: 'Worry-free Protection Plan',
  LC_WISHLIST_PROTECTION_PLAN_LINK: 'LensCrafters Care Coverage',
  WISHLIST_PROTECTION_PLAN_PRICE: '(One year coverage: $##WARRANTY_PRICE##)',
  WISHLIST_SUBTOTAL: 'SUBTOTAL',
  WISHLIST_ADD_TO_CART: 'ADD TO CART',
  LC_WISHLIST_ADD_TO_CART: 'ADD TO BAG',
  WISHLIST_EDIT_LENSES: 'Edit lenses',
  WISHLIST_NO_PRESCRIPTION: 'No prescription',
  WISHLIST_LOAD_MORE_BTN: 'Load more',
  WISHLIST_MISSING_PRESCRIPTION: `We are missing your prescription.<br />We'll ask for it if you proceed with your order.`,
  WISHLIST_OUT_OF_STOCK: 'out of stock',
  WISHLIST_OUT_OF_STOCK_CTA: "Email me when it's back",
  WISHLIST_FIND_TRY_BTN: 'Find and try in store',
};
